function getLocation() {
  return hasWindow() ? window.location : undefined;
}
function getWindow() {
  return hasWindow() ? window : undefined;
}
function hasWindow() {
  return typeof window !== 'undefined';
}
export default {
  getLocation: getLocation,
  getWindow: getWindow
};